// English strings of the quality panel (decision D13: English first). Another
// language adds a file next to this one with the same shape.

export const strings = {
  title: "Quality",
  legend: "Sound quality",
  auto: "Auto",
  autoHint: "Plays the most detailed live tier this computer keeps up with, and steps down before the sound drops out.",
  /** A tier's label from its id, such as "Live high" for live-high. */
  tier: (id: string) => id.charAt(0).toUpperCase() + id.slice(1).replace(/-/g, " "),
  offline: "for offline renders; it may not keep up live",
  none: "This voice has one quality only.",
  off: "Start the audio to see the load.",
  playing: "Playing",
  load: "Load",
  loadValue: (percent: number) => `${percent.toFixed(1)} % of the audio thread`,
  measuring: "measuring…",
  misses: "Dropouts",
  missesValue: (n: number, source: "underruns" | "stalls") =>
    `${n} since the start (${source === "underruns" ? "reported by the browser" : "estimated from stalls"})`,
  last: "Last change",
  /** The last change of tier: why, to which tier, when (audio time) and the load that caused it. */
  change: (reason: "start" | "chosen" | "overload" | "miss" | "headroom", to: string, time: number, load: number | null): string => {
    const at = `at ${time.toFixed(1)} s`;
    const pct = load === null ? "" : `${(100 * load).toFixed(0)} %`;
    switch (reason) {
      case "start":
        return `Started at ${to}`;
      case "chosen":
        return `Chose ${to} ${at}`;
      case "overload":
        return `Stepped down to ${to} ${at} (load ${pct})`;
      case "miss":
        return `Stepped down to ${to} ${at} (a dropout at load ${pct})`;
      case "headroom":
        return `Stepped up to ${to} ${at} (room to spare)`;
    }
  },
} as const;
